// 項目情報に関する共通処理を定義

import { executeGetHasUsagePermission, executePostCategory, executeGetCategorySpecifyMaster } from '../../dataAccess/webApi/dao/categoryMstDao'
import { GetCategoryMstDto, GetCategorySpecifyMasterInputDto, PostCategoryMstDto, PostCategoryMstInputDto } from '../../dataAccess/webApi/dto/categoryMstDto'
import { Flag } from '../../containers/common/constant/classification'

export { SpecifyMasterType } from '../../dataAccess/webApi/dao/categoryMstDao'

export const FIELD_TYPE = {
  RADIO: '1',
  CHECK_BOX: '2',
  ONE_LINE: '3',
  MULTI_LINE: '4',
  NUMBER: '5',
  DECIMAL: '6',
  DATE: '7'
} as const

const EDIT_CITIZEN = {
  UNEDITABLE: '0', // 不可
  EDITABLE: '1', // 可
  ONLY_BEFORE_APPROVED: '2' // 利用許可されるまで可
}  as const

/**
 * 項目一覧を返す。
 *
 * @param input
 * @returns 項目一覧
 */
export const getCategories = async (input: PostCategoryMstInputDto): Promise<PostCategoryMstDto[]> => {
  const response = await executePostCategory(input)

  return response.result
}

/**
 * 
 * 項目一覧（専用マスタ用）を返す。
 *
 * @param input
 * @returns 項目（専用マスタ用一覧
 */
export const getCategorySpecifyMasters = async (input: GetCategorySpecifyMasterInputDto): Promise<PostCategoryMstDto[]> => {
  const response = await executeGetCategorySpecifyMaster(input.masterType, input.projectId, input.category)

  return response.result
}

// 利用許可が1つでもあるかチェック（項目編集可否制御用）
export const getHasUsagePermission = async (childId: string): Promise<boolean> => {
  const response = await executeGetHasUsagePermission(childId)
  return response.result
}

/**
 * 
 * Flagを存在チェック表示用テキストに変換する
 *
 * @param input
 * @returns 存在チェック表示用テキスト
 */
export const getYesNoText = (categoryMst: GetCategoryMstDto, value: string | undefined): string => {
  if (value == null) return '登録なし'
  return value === Flag.ON ? categoryMst.checkTextYes ?? 'あり'
                           : categoryMst.checkTextNo ?? 'なし'
}

/**
 * 
 * 市民の編集可否を判定する
 *
 * @param editCitizen categoryGroupのeditCitizen値
 * @param hasUsagePermission お子様に利用許可が1つでもあるか
 * @returns 編集可否
 */
export const isEditable = (editCitizen: string | null | undefined, hasUsagePermission: boolean | null | undefined): boolean => {
  if (editCitizen == null || hasUsagePermission == null) return true
  if (editCitizen !== EDIT_CITIZEN.ONLY_BEFORE_APPROVED) {
    return !(editCitizen === EDIT_CITIZEN.UNEDITABLE)
  } else {
    return !hasUsagePermission
  }
}